module.exports = __webpack_public_path__ + "static/media/crysta.559595a6.png";